import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, normalizeStyle as _normalizeStyle } from "vue"

import NavigationBar from "@/components/NavigationBar.vue";
import TitleBar from "@/components/TitleBar.vue";
import { useRefreshComponent } from "@/stores/refreshComponent";
import { ref } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'DashboardLayout',
  setup(__props) {

const { refreshTitleBarKey } = useRefreshComponent();
const isCollapsed = ref(false);

return (_ctx: any,_cache: any) => {
  const _component_ElAside = _resolveComponent("ElAside")!
  const _component_ElHeader = _resolveComponent("ElHeader")!
  const _component_RouterView = _resolveComponent("RouterView")!
  const _component_ElMain = _resolveComponent("ElMain")!
  const _component_ElContainer = _resolveComponent("ElContainer")!

  return (_openBlock(), _createBlock(_component_ElContainer, null, {
    default: _withCtx(() => [
      _createVNode(_component_ElAside, {
        width: isCollapsed.value ? '60px' : '200px',
        class: "el-aside",
        style: {"position":"fixed","top":"0"}
      }, {
        default: _withCtx(() => [
          _createVNode(NavigationBar, {
            "is-collapsed": isCollapsed.value,
            onToggleCollapse: _cache[0] || (_cache[0] = ($event: any) => (isCollapsed.value = !isCollapsed.value))
          }, null, 8, ["is-collapsed"])
        ]),
        _: 1
      }, 8, ["width"]),
      _createVNode(_component_ElContainer, {
        style: _normalizeStyle({ marginLeft: isCollapsed.value ? '60px' : '200px' })
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ElHeader, {
            class: "el-header",
            style: _normalizeStyle({
          position: 'fixed',
          top: 0,
          left: isCollapsed.value ? '60px' : '200px',
          right: 0,
          paddingLeft: 0,
        })
          }, {
            default: _withCtx(() => [
              (_openBlock(), _createBlock(TitleBar, { key: _unref(refreshTitleBarKey) }))
            ]),
            _: 1
          }, 8, ["style"]),
          _createVNode(_component_ElMain, {
            style: _normalizeStyle({
          position: 'fixed',
          top: '60px',
          width: isCollapsed.value ? 'calc(100% - 60px)' : 'calc(100% - 200px)',
          height: 'calc(100vh - 60px)',
        })
          }, {
            default: _withCtx(() => [
              _createVNode(_component_RouterView)
            ]),
            _: 1
          }, 8, ["style"])
        ]),
        _: 1
      }, 8, ["style"])
    ]),
    _: 1
  }))
}
}

})